import makkah1 from "../images/makkah1.jpeg";
import makkah2 from "../images/makkah2.jpeg";
import makkah3 from "../images/makkah3.jpeg";
import makkah4 from "../images/makkah4.jpeg";
import makkah5 from "../images/makkah5.jpeg";
import madina1 from "../images/madina1.jpeg";
import madina2 from "../images/madina2.jpeg";
import madina3 from "../images/madina3.jpeg";
import madina4 from "../images/madina4.jpeg";
import madina5 from "../images/madina5.jpeg";
import SectionHeading from "./ui/SectionHeading";
import Reveal from "./ui/Reveal";

const HotelGrid = ({ title, images }) => (
  <section className="flex-1">
    <h3 className="mb-6 text-center text-2xl font-bold text-brand-dark">
      <span className="text-brand-green">{title}</span> Hotels
    </h3>
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
      {images.map((img, index) => (
        <Reveal key={index} delay={index * 0.06}>
          <div className="group overflow-hidden rounded-2xl shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-glow">
            <img
              src={img}
              alt={`${title} Hotel ${index + 1}`}
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

const Hotels = () => {
  const makkahImages = [makkah1, makkah2, makkah3, makkah4, makkah5];
  const madinaImages = [madina1, madina2, madina3, madina4, madina5];
  return (
    <section id="hotels" className="section-pad bg-[#dfecd5]">
      <SectionHeading
        eyebrow="Stay Close to the Haram"
        title="Premium Hotels"
        subtitle="Hand-picked 5-star and budget-friendly stays in Makkah and Madina, steps from the Haram."
      />
      <div className="container mx-auto flex flex-col gap-10 md:flex-row">
        <HotelGrid title="Makkah" images={makkahImages} />
        <HotelGrid title="Madina" images={madinaImages} />
      </div>
    </section>
  );
};

export default Hotels;
